var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPolicyDetail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 68,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M17.305 56.748V6.665a3.474 3.474 0 013.472-3.468h36.666a3.474 3.474 0 013.472 3.468v50.083a3.474 3.474 0 01-3.472 3.468H20.777a3.474 3.474 0 01-3.472-3.468z",
    fill: "#291475"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 55.021V4.94a3.474 3.474 0 013.473-3.469h36.665A3.474 3.474 0 0158.61 4.94V55.02a3.474 3.474 0 01-3.473 3.469H18.473A3.474 3.474 0 0115 55.02z",
    fill: "#ED1B2E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.586 55.424l.001-50.884-37.568-.001-.002 50.883 37.569.002z",
    fill: "#FEFFFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.046 10.089H20.01v4.439h20.037v-4.44z",
    fill: "#B0B0B0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M51.066 16.747H20.01v4.44h31.057v-4.44z",
    fill: "#B0B0B0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.046 30.266H20.01v4.439h20.037v-4.44z",
    fill: "#B0B0B0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M51.066 36.924H20.01v4.44h31.057v-4.44z",
    fill: "#B0B0B0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M58.61 4.005l-.007 51.957c0 1.4-1.13 2.528-2.53 2.528H17.53A2.534 2.534 0 0115 55.962V53.94l36.393.008a2.53 2.53 0 002.53-2.535l.008-49.943h2.149a2.536 2.536 0 012.53 2.535z",
    fill: "#291475"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M68.629 6.325l-.82-.446-.819-.445a2.282 2.282 0 00-3.105.931l-4.578 8.477-.257.466L45.1 41.153l-.014.162-.362 4.412-.276 3.417 2.695-2.092 3.487-2.71.127-.094 13.96-25.841 1-1.852 3.828-7.088c.605-1.14.19-2.534-.916-3.142z",
    fill: "#291475"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M64.549 4.43l1.63.893c1.114.604 1.52 2 .916 3.123L48.281 43.237l-.127.094-3.49 2.711-2.697 2.094.279-3.417.364-4.41.014-.162L61.44 5.355a2.3 2.3 0 013.11-.924z",
    fill: "#ED1B2E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M57.58 12.45l-1 1.857 5.65 3.092 1-1.856-5.65-3.093z",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M64.507 4.43l1.63.893c1.115.604 1.521 2 .917 3.124l-3.834 7.09-5.654-3.085L61.4 5.364a2.293 2.293 0 013.107-.932z",
    fill: "#ED1B2E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M42.669 40.312l5.534 3.018-3.483 2.71-2.702 2.103.279-3.417.372-4.414z",
    fill: "#FFDF8C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M42.304 44.726l2.423 1.313-2.702 2.104.279-3.417z",
    fill: "#000"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M65.368 4.878l.82.445c1.113.604 1.52 2 .915 3.123L48.29 43.235l-.127.093-3.49 2.711-2.696 2.094L65.368 4.878z",
    fill: "#ED1B2E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M28.323 44.932l-.796-.297-2.434-.92.628-1.698c.141-.369.115-.759-.036-1.095a1.431 1.431 0 00-.793-.75 1.417 1.417 0 00-1.83.843l-.629 1.698-6.412-2.421.628-1.698c.14-.37.114-.76-.037-1.095a1.431 1.431 0 00-.793-.75 1.417 1.417 0 00-1.83.843l-.628 1.698-3.23-1.217a1.783 1.783 0 00-2.304 1.056L1.835 55.3a1.808 1.808 0 001.05 2.323l18.192 6.867c.928.349 1.96-.12 2.304-1.056l5.1-13.764.891-2.405a1.814 1.814 0 00-1.049-2.332z",
    fill: "#291475"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M28.408 45.141l-5.986 16.16a1.777 1.777 0 01-2.305 1.054l-18.2-6.872A1.809 1.809 0 01.865 53.16L6.852 37a1.777 1.777 0 012.304-1.055l18.2 6.873a1.809 1.809 0 011.052 2.323z",
    fill: "#D8D8D8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M28.409 45.128l-.89 2.402-21.555-8.134.89-2.401a1.776 1.776 0 012.303-1.054l18.193 6.866a1.805 1.805 0 011.058 2.321z",
    fill: "#000"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M28.403 45.145l-5.985 16.156a1.776 1.776 0 01-2.304 1.054l-18.198-6.87a1.808 1.808 0 01-1.05-2.323l.454-1.225 17.41 6.566c.929.348 1.96-.12 2.304-1.055l5.53-14.922.796.297a1.81 1.81 0 011.043 2.322z",
    fill: "#291475"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M15.69 36.469l-1.09 2.937a1.424 1.424 0 01-1.834.84 1.445 1.445 0 01-.841-1.846l1.09-2.937a1.424 1.424 0 011.834-.84c.367.143.644.415.795.75.16.329.187.719.046 1.096z",
    fill: "#D8D8D8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M15.69 36.468l-1.092 2.938a1.425 1.425 0 01-1.834.84l2.084-5.624c.367.142.644.415.796.75.16.329.187.719.046 1.096z",
    fill: "#291475"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M24.756 39.89l-1.09 2.936a1.424 1.424 0 01-1.833.84 1.445 1.445 0 01-.841-1.845l1.09-2.937a1.424 1.424 0 011.833-.84c.367.142.644.415.796.75.16.328.187.718.045 1.095z",
    fill: "#D8D8D8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M24.756 39.888l-1.091 2.938a1.425 1.425 0 01-1.835.84l2.084-5.624c.368.142.645.415.796.75.16.33.188.72.046 1.096z",
    fill: "#291475"
  })));
}

export default SvgPolicyDetail;